import { useEffect, useState } from 'react'
import { Text, VStack, Table, Tr, Tbody, Td, Link, useToast } from '@chakra-ui/react'
import { useMonthlyCourse } from '@!/Hooks/useMonthlyCourse'
import { CircularProgressModal, YesNoPopupModal } from '@!/components/Modal'

const MonthlyCourseUnregister = ({ registers }) => {
  const toast = useToast()
  const { unregisterMonthlyCourseMutation, apiError } = useMonthlyCourse()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedOrderId, setSelectedOrderId] = useState(null)

  const handleUnregister = (orderId) => {
    setSelectedOrderId(orderId)
    setIsModalOpen(true)
  }

  const handleConfirmUnregister = () => {
    if (selectedOrderId) {
      unregisterMonthlyCourseMutation.mutate(selectedOrderId)
    }
    setIsModalOpen(false)
    setSelectedOrderId(null)
  }

  const handleCancelUnregister = () => {
    setIsModalOpen(false)
    setSelectedOrderId(null)
  }

  useEffect(() => {
    if (!unregisterMonthlyCourseMutation.isSuccess) return

    window.location.href = '/user/monthly_course_unregister/complete'
  }, [unregisterMonthlyCourseMutation.isSuccess])

  useEffect(() => {
    if (!apiError.error) return

    let title, description

    switch (apiError.error) {
      case 'NOT_REGISTERED':
        title = '月額コースに登録されていません'
        description = '問題が解決しない場合はお問い合わせください。'
        break
      case 'FAILED_UNREGISTER':
        title = '月額コースの解除に失敗しました'
        description = 'しばらく時間をおいて再度お試しください。'
        break
      case 'INVALID_PARAMS':
      default:
        title = 'エラーが発生しました'
        description = 'しばらく時間をおいて再度お試しください。'
    }

    toast({
      title,
      description,
      status: 'error',
      duration: 5000,
      isClosable: true,
    })

    setIsModalOpen(false)
    setSelectedOrderId(null)
  }, [apiError, toast])

  return (
    <VStack minH="50vh" spacing={4} py={8} justifyContent="space-between">
      <VStack spacing={4} w="full">
        <Text fontSize="2xl" fontWeight="semibold" pb={2}>
          月額解除ページ
        </Text>
        <Text fontSize="xs">{registers && registers.length > 0 ? '以下の月額コースに登録しています。' : '月額コースに登録していません。'}</Text>
        {registers && registers.length > 0 && (
          <Table width="full" variant="simple" borderTopWidth="1px">
            <Tbody>
              {registers.map((register, index) => (
                <Tr key={`monthly-course-unregister-${index}`}>
                  <Td fontWeight="600" fontSize="xs" lineHeight="20px">
                    {register.monthly_course_name}
                  </Td>
                  <Td textAlign="center" fontWeight="600" fontSize="xs" lineHeight="20px">
                    <Link onClick={() => handleUnregister(register.order_id)} data-gtm-subscription={`cancel_${register.amount}`}>
                      解除
                    </Link>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </VStack>
      <Link href="/" fontSize="xs">
        トップに戻る
      </Link>
      <CircularProgressModal isOpen={unregisterMonthlyCourseMutation.isPending} />
      <YesNoPopupModal
        title={'登録を解除します。よろしいですか？'}
        handleCancel={handleCancelUnregister}
        handleSubmit={handleConfirmUnregister}
        cancelTitle={'キャンセル'}
        submitTitle={'はい'}
        isOpen={isModalOpen}
      />
    </VStack>
  )
}

export default MonthlyCourseUnregister
